import { FC } from 'react';
import { FormStyled } from '../../CustomForm.styled';
import Select from '../../../../../design-system/components-v2/SelectV2';
import { FieldLabelComponent } from '../helperComponents/FieldLabelComponent';
import { getItemSelectPlaceholder } from '../../CustomForm.values';
import { IOnFieldChanged, IMultiSelectItem, IFullErrorInfo } from '../../CustomForm.interface';
import ItemComponentBottomArea from '../helperComponents/ItemComponentBottomArea';

export interface IMultiSelectComponentProps {
    item: IMultiSelectItem;
    onFieldChanged: IOnFieldChanged;
    showErrors: boolean;
    errorInfo?: IFullErrorInfo;
    skipTitle?: boolean;
    isInner?: boolean;
}

export const MultiSelectItemComponent: FC<IMultiSelectComponentProps> = ({
    item,
    onFieldChanged,
    showErrors,
    errorInfo,
    skipTitle,
    isInner,
}) => {
    const { state } = item;
    return (
        <FormStyled.TopItem widthInfo={state.widthInfo} isInner={isInner}>
            {!skipTitle && <FieldLabelComponent item={item} />}
            <Select
                value={state.value}
                onChange={(values) => onFieldChanged({ ...item, state: { ...state, value: values } })}
                placeholder={getItemSelectPlaceholder(item)}
                options={state.options || []}
                fullWidth
                clearable
                isMulti={true}
                isError={!!(showErrors && errorInfo)}
                disabled={state.disabled || state.readonly}
            />
            <ItemComponentBottomArea state={state} showErrors={showErrors} errorInfo={errorInfo} />
        </FormStyled.TopItem>
    );
};
